import { render, staticRenderFns } from "./JCommNotification.vue?vue&type=template&id=5f42dcde&"
import script from "./JCommNotification.vue?vue&type=script&lang=js&"
export * from "./JCommNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports